import axios from './axios'

const apiVersion = 'v1'

const resendEmailVerification = async () => {
  const apiPath = 'user.profile'
  const apiAction = 'resend.verification'
  const url = `${apiVersion}/${apiPath}/${apiAction}/`

  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((res) => resolve(res))
      .catch(err => reject(err))
  })
}

const loginWithPassword = async ({ username, password }) => {
  const url = `${apiVersion}/auth/`
  const authorizationData = `${username}:${password}`
  const authorization = Buffer.from(authorizationData, 'utf8').toString('base64')
  const options = {
    headers: {
      Authorization: `Basic ${authorization}`
    }
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url, options)
      .then(res => resolve(res.data))
      .catch(err => reject(err))
  })

}

const loginWithPin = async ({ username, password, pin }) => {
  const searchParams = new URLSearchParams({ username, password, pin })
  const url = `${apiVersion}/auth.pin/?${searchParams}`

  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(res => resolve(res.data))
      .catch(err => reject(err))
  })
}

const logout = async () => {
  const apiAction = 'logout'
  let url = `${apiVersion}/${apiAction}/`

  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

const api = { resendEmailVerification, logout, loginWithPassword, loginWithPin }

export default api